import { useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { SubmitHandler, useForm  } from "react-hook-form";
import { resetStateLegislature, startNewLegislature, startUpdatedLegislature } from "../../actions/legislatureActions";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";


interface Props {
  open: boolean;
  handleClose: () => void;
}
type Inputs = {
  id:string;
  name: string;
};
const ModalLegislature = ({ open, handleClose }: Props) => {

  const dispatch = useAppDispatch();
  const {update , legislatureSelected , legislatures }  = useAppSelector((state)=>state.legislature);
  const {loading} = useAppSelector((state)=>state.ui);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
    } = useForm<Inputs>({
    defaultValues:legislatureSelected
  });

  useEffect(() => {
    if(legislatureSelected){
      setValue("name",legislatureSelected.name ,  { shouldDirty: true });
    }else{
      setValue("name","", { shouldDirty: true });
    }
    // eslint-disable-next-line
  }, [legislatureSelected, legislatures]);

  const handleResetForm = () =>{
    dispatch(resetStateLegislature());
    handleClose();
  }

  const onSubmit: SubmitHandler<Inputs> = (data) => {

    if(update){
      dispatch(startUpdatedLegislature(data));
    }else{
     dispatch(startNewLegislature(data)); 
    }
    
    handleResetForm();
  };

  return (
    <Modal show={open} onHide={handleResetForm}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title> {update ? 'Editar Legislatura' : 'Agregar Legislatura'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Nombre legislatura:</Form.Label>
            <Form.Control
              type="text"
              placeholder="ej: 2021-2024"
              {...register("name", {
                required: true,
              })}
            />
            {errors.name && <p className="text-danger">El nombre de la legislatura es requerida</p>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleResetForm}>
            Cerrar
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            Guardar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

ModalLegislature.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default ModalLegislature;
